import { getAppCopy } from '../../../i18n';
import { getBillingApiBase } from '../billingApi';
import { formatRedeemCodeDisplay } from '../redeemCodeFormat';
import { getAppStoreSubscriptionForRedeemUnified } from './appStoreRouter';

export interface IssuedRedeemCode {
  code: string;
  formattedCode: string;
  expiresAt: string;
}

interface IssueResponse {
  code?: string;
  formattedCode?: string;
  expiresAt?: string;
  error?: string;
}

export async function issueWebRedeemCode(): Promise<IssuedRedeemCode> {
  const subscription = await getAppStoreSubscriptionForRedeemUnified();
  if (!subscription) {
    throw new Error(getAppCopy().billingErrors.redeemIssueUnavailable);
  }

  const body =
    subscription.source === 'microsoft'
      ? {
          source: 'microsoft',
          store_subscription_id: subscription.storeSubscriptionId ?? '',
          user_collection_id: subscription.userCollectionId ?? '',
        }
      : {
          source: 'appstore',
          original_transaction_id: subscription.originalTransactionId ?? '',
        };

  const response = await fetch(`${getBillingApiBase()}/issue-redeem-code.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = (await response.json().catch(() => ({}))) as IssueResponse;
  if (!response.ok || !data.code) {
    throw new Error(data.error || getAppCopy().billingErrors.redeemIssueFailed);
  }

  const code = data.code;
  return {
    code,
    formattedCode: formatRedeemCodeDisplay(data.formattedCode || code),
    expiresAt: data.expiresAt || '',
  };
}
